<template>
  <PageLoading :loading="pageLoaded" v-if="!isRepairing && pageLoaded" />
  <Layout v-else />
</template>
<script setup lang="ts">
import { onBeforeMount, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Layout from './layout';
import {
  storeToRefs,
  useAppStore,
  useDeviceStore,
  useGameStore,
  useModalStore,
  useMsgStore,
  useTenantStore,
  useUserStore,
} from '@star/stores';
import { useDownloadApp, useScript } from '@/hooks';
import { useAiValidate } from '@star/hooks';
import { emitter, EventEnum } from '@star/utils';
import { getChanCon } from '@/hooks/message';
import PageLoading from '@/components/pageLoading/index.vue';
import { startsWith } from 'lodash-es';
import { useWindowSize } from '@vueuse/core';

const router = useRouter();
const route = useRoute();
const appStore = useAppStore();
const tenantState = useTenantStore();
const gameStore = useGameStore();
const userStore = useUserStore();
const modalStore = useModalStore();
const msgStore = useMsgStore();
const { theme, template } = storeToRefs(appStore);
const { tenantInfo, isRepairing, isReqPlatformData } = storeToRefs(tenantState);
const { isLogin } = storeToRefs(userStore);
// const { isOpenCp } = storeToRefs(gameStore);
// const game3LoginInfo = getJSON('game3LoginInfo') || {};
const pageLoaded = ref(false);
const downloadApp = useDownloadApp();
const { loadCaptcha } = useAiValidate();
const { initScript } = useScript();
const { width, height } = useWindowSize();

// const bus = useEventBus(BusEnum.GLOBAL);

// bus.on((event: string, payload: any) => {
//   if (event === EventEnum.SHOW_GET_PLAY_MONEY) {
//     showGetPlayMoney(payload);
//   }
// })

const init = async (loading: boolean = true) => {
  try {
    pageLoaded.value = loading;
    console.log(loading, tenantInfo.value?.tid, isReqPlatformData.value, isRepairing.value, 'loading');
    if (isReqPlatformData.value) {
      await appStore.init();
      await tenantState.getPlatformData();
      if (tenantInfo.value?.tid) {
        try {
          loadCaptcha();
          initScript();
        } catch (e) {}
      }
    }
    // await tenantState.reqRepairData();
    if (tenantInfo.value?.tid) {
      await tenantState.reqContactConfig();
      if (route.name === 'home') {
        pageLoaded.value = false;
        await modalStore.initModalList();
        await downloadApp.loadScript();
      }
      if (tenantInfo.value.domain_tenant_id) {
        try {
          await gameStore.getHotGamesPlatform();
          await gameStore.getHotGamesPlatform(); //再次发起，解决首页热门游戏显示异常
        } catch (e) {}
        await gameStore.getTotalGamesPlatform({ chan_con: getChanCon(), updateNews: true });
      }
      if (isLogin.value) {
        await userStore.reqHasPassword({ type: 1 });
        await userStore.reqHasPassword({ type: 2 });
        await userStore.setLoginPassword(router);
      }
    }
  } finally {
    pageLoaded.value = false;
    isReqPlatformData.value = true;
  }
};

watch(
  () => template.value,
  newVal => {
    if (newVal) {
      document.documentElement.setAttribute('data-template-v', newVal);
    }
  },
  {
    immediate: true,
  }
);

watch(
  () => [width.value, height.value],
  value => {
    console.log(value, '000000001111111');
    document.documentElement.style.setProperty('--vh', `${height.value * 0.01}px`); // 设置 CSS 变量
    document.documentElement.style.setProperty('--view-width', `${width.value > 450 ? 450 : width.value}px`); // 设置 CSS 变量
    document.documentElement.style.setProperty('--view-height', `${height.value}px`); // 设置 CSS 变量
  },
  {
    immediate: true,
  }
);

watch(
  () => isLogin.value,
  newVal => {
    if (newVal) {
      msgStore.reqMessageUnread();
    }
  },
  {
    immediate: true,
  }
);

emitter.on(EventEnum.PAGE_API_RELOAD, async () => {
  await init(false);
});

onBeforeMount(async () => {
  await init();
});

onMounted(async () => {
  if (isLogin.value && startsWith(location.pathname, '/trial')) {
    await router.push('/home/103');
  }
});
</script>
<style scoped lang="less">
.page {
  padding: 0;
  background: skyblue;
}

.replace-page {
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
